<template>
	<div class="scissors-layout">
		<app-mobile-menu />
		<app-header />
		<transition name="fade-page" mode="out-in">
			<component :is="page"/>
		</transition>
		<app-footer />
		<app-lightbox />
		<app-notification />
	</div>
</template>

<script>
	import Tour360 from './pages/tour360.vue'
	import Video from './pages/video.vue'
	import Slideshow from './pages/slideshow.vue'
	import Gallery from './pages/gallery.vue'
	import Details from './pages/details.vue'
	import WalkScore from './pages/walkScore.vue'
	import Map from './pages/map.vue'
	import Floorplan from './pages/floorplan.vue'
	import Contact from './pages/contact.vue'

	import Header from '@/components/header/header.vue'
	import MobileMenu from '@/components/mobileMenu/mobileMenu.vue'
	import Footer from '@/components/footer/footer.vue'
	import Lightbox from '@/components/lightbox/lightbox.vue'
	import Notification from '@/components/notification/notification.vue'
	
	export default {
		components: {
			appVideo: Video,
			appDetails: Details,
			appTour360: Tour360,
			appGallery: Gallery,
			appSlideshow: Slideshow,
			appFloorplan: Floorplan,
			appWalkScore: WalkScore,
			appMap: Map,
			appContact: Contact,
			appHeader: Header,
			appMobileMenu: MobileMenu,
			appFooter: Footer,
			appLightbox: Lightbox,
			appNotification: Notification
		},
		computed: {
			page () {
				const { name } = this.$route

				return `app-${name}`
			}
		}
	}
</script>

<style lang="scss">
	@import "~@/styles/variables";
	@import "@/styles/mixins.scss";

	.scissors-layout {
		min-height: 100vh;
		display: grid;
    grid-template-rows: auto 1fr;

		// display: flex;
		// flex-direction: column;
		
		// .header,
		// .footer {
		//	flex-shrink: 0;
		// }

		// .section {
		//	flex-grow: 1;
		// }

		&[data-theme="light"] {
			--color-header: rgba(0,0,0,.85);
		}

		&[data-theme="dark"] {
			--color-header: rgba(255,255,255,.95);

			background-color: var(--color-section-primary);
		}

		.section {
			padding-top: $height-header-small;
			padding-bottom: 5rem;

			@include min-screen($media-header-medium) {
				padding-top: $height-header-medium;
			}

			@include min-screen($media-header-large) {
				padding-top: $height-header-large;
			}

			&--video {
				margin-top: -3.75rem;
				padding: 0;

				@include min-screen($media-header-medium) {
					margin-top: -5.125rem;
				}

				@include min-screen($media-header-large) {
					margin-top: -5.75rem;
				}

				.video {
					position: relative;
					width: 100%;
					height: 100%;
				}

				.full-sticky-bg {
					position: relative;
					height: 100%;
				}
			}

			&--details {
				overflow: hidden;
				padding-bottom: 3.125rem;

				@include tablet() {
					padding-bottom: 7.5rem;
				}
			}

			&--gallery {
				padding: 0;
			}

			&--map {
				padding: 0;

				.map {
					height: 100vh;
					margin-top: -$height-header-small;

					@include min-screen($media-header-medium) {
						margin-top: -$height-header-medium;
					}

					@include min-screen($media-header-large) {
						margin-top: -$height-header-large;
					}
				}
			}
		}
	}
</style>
